import { FC } from 'react'
import { IconProps } from '@chakra-ui/react'

import { Suitcase } from 'components/icons'

interface CustomIconProps extends IconProps {
  variant?: string
  color?: string
}

const OrganizationalUnit: FC<CustomIconProps> = (props) => {
  return <Suitcase {...props} />
}

const OrganizationalUnitExports = {
  OrganizationalUnit,
}

export default OrganizationalUnitExports
